import React from "react";
var __jsx = React.createElement;
import CustomInput from "@modules/shared/components/custom-input";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
import { useMediaQuery } from "react-responsive";
import { BREAKPOINTS } from "@lib/constants";
import moment from "moment";
import { useMemo, useState, useRef, useEffect } from "react";
const TimePickerInput = _ref => {
  let {
    label = "",
    className = "",
    value,
    onChangeValue,
    hasErrors = false,
    errorMessage = "",
    customInputClass,
    dataTestId,
    onClick,
    disablePopper = false,
    hideLabel = false,
    disableLabelAnimation = false,
    placeholder = "HH:MM AM/PM",
    useBorderlessStyle = false,
    showBorder = true
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const {
    0: inputValue,
    1: setInputValue
  } = useState("");
  const containerRef = useRef(null);
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    cssModules
  } = useCssModules();
  const {
    borderlessInput,
    borderlessInputContainer,
    borderlessInputFocus,
    borderlessInputText,
    borderlessInputLabel,
    borderlessInputLabelSmall,
    borderlessInputClearButton,
    borderlessInputIcon,
    borderlessDropdown,
    borderlessOption,
    borderlessOptionTitle,
    borderlessOptionSubtitle
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.Autocomplete) || {};
  const timeOptions = useMemo(() => ["12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM", "6:00 AM", "6:30 AM", "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM", "9:00 PM", "9:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM"], []);

  // Initialize input value from prop
  useEffect(() => {
    if (value) {
      setInputValue(moment(value).format("h:mm A"));
    }
  }, [value]);

  // Handle click outside to close dropdown (desktop only)
  useEffect(() => {
    if (useBorderlessStyle) return; // Skip for mobile

    const handleClickOutside = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [useBorderlessStyle]);
  const handleInputClick = () => {
    if (useBorderlessStyle && onClick) {
      // For mobile with onClick prop, use the onClick prop to open the mobile panel
      onClick();
    } else {
      // For desktop or mobile without onClick prop, show the dropdown
      setIsOpen(true);
    }
  };
  const handleSelectTime = timeString => {
    const time = moment(timeString, "h:mm A");
    const newDate = moment(value || new Date()).set("hour", time.hour()).set("minute", time.minute()).set("seconds", 0).set("milliseconds", 0).toDate();
    setInputValue(timeString);
    onChangeValue === null || onChangeValue === void 0 || onChangeValue(newDate);
    setIsOpen(false);
  };
  const handleInputChange = e => {
    setInputValue(e.target.value);
  };
  return __jsx("div", {
    onClick: onClick,
    ref: containerRef,
    className: cn("relative", className)
  }, __jsx(CustomInput, {
    value: inputValue,
    onChange: handleInputChange,
    onClick: handleInputClick,
    placeholder: placeholder,
    label: hideLabel ? "" : label,
    error: hasErrors,
    helperText: errorMessage,
    customInputClass: cn(isMobile && borderlessInput),
    dataTestId: dataTestId,
    disableLabelAnimation: disableLabelAnimation,
    containerClassName: cn(isMobile && borderlessInputContainer),
    showBorder: showBorder
  }), isOpen && !disablePopper && (!useBorderlessStyle || !onClick) && __jsx("div", {
    className: cn("absolute z-50 w-full max-h-96 md:max-h-60 overflow-y-auto mt-1", !isMobile && "bg-white border border-gray-200 rounded-lg shadow-lg mt-1")
  }, timeOptions.map((timeString, index) => __jsx("div", {
    key: "".concat(timeString, "-").concat(index),
    className: cn("flex items-center cursor-pointer p-2 hover:bg-gray-50 hover:text-primary-main", useBorderlessStyle && borderlessOption ? borderlessOption : ""),
    onClick: () => handleSelectTime(timeString)
  }, __jsx("p", {
    className: cn("font-medium text-primary_text py-2", useBorderlessStyle && borderlessOptionTitle ? borderlessOptionTitle : "")
  }, timeString)))));
};
export default TimePickerInput;